"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

var variantClasses = {
  error: 'bg-error text-red',
  info: 'bg-secondary text-primary',
  warning: 'bg-orange text-white'
};

var Container = function Container(_ref) {
  var _cn;

  var variant = _ref.variant,
      className = _ref.className,
      transparent = _ref.transparent,
      children = _ref.children;
  var classes = (0, _get["default"])(variantClasses, variant, variantClasses.info);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative px-16 h-16 flex items-center flex-shrink-0', className, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes, !transparent), (0, _defineProperty2["default"])(_cn, '!bg-transparent', transparent), (0, _defineProperty2["default"])(_cn, 'text-white', transparent && variant !== 'error'), (0, _defineProperty2["default"])(_cn, 'text-red', transparent && variant === 'error'), _cn)),
    style: {
      zIndex: 1
    }
  }, children);
};

var _default = Container;
exports["default"] = _default;
//# sourceMappingURL=Container.js.map